import React from "react";
import "./App.css";
import ResumeTree from "./ResumeTree";
import resumeData from "./resumeData.json";

function App() {
  return <ResumeTree data={resumeData} />;
}

export default App;
